<script setup>

import {useRoute, useRouter} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {onMounted} from "vue";
import {useUserPoapStore} from "@/stores/userPoap.store";
import {useUserLocationStore} from "@/stores/userLocation.store";
import dayjs from 'dayjs';


const route = useRoute();
const router = useRouter();
const userPoapStore = useUserPoapStore();
const userLocationStore = useUserLocationStore();

const {userPoap} = storeToRefs(userPoapStore);
const {userLocations} = storeToRefs(userLocationStore);

onMounted(async () => {
    if (route.params.id > 0) {
        await userPoapStore.fetchOne(route.params.id);
    } else {
        userPoapStore.reset();
        await userLocationStore.fetchLatest();
    }
});

const doSubmit = async () => {
    const datetime = dayjs().format('YYYY-MM-DD HH:mm:ss');

    if (route.params.id === '0') {
        userPoap.value.checkin_at_formatted = datetime;
        await userPoapStore.createOne().then(() => {
            router.push('/poap/' + userPoap.value.id);
        });
    } else {
        userPoap.value.checkout_at_formatted = datetime;
        await userPoapStore.updateOne(route.params.id);
    }
};

</script>

<template>
    <van-form @submit="doSubmit">
        <van-cell-group inset>
            <van-divider/>
            <van-row justify="left">
                <b>POAP</b>
            </van-row>

            <van-divider/>

            <van-field
                v-model="userPoap.name"
                placeholder="Event Name"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input your POAP Event' }]"
            />
            <van-field
                v-model="userPoap.description"
                placeholder="Description"
                size="large"
                :rules="[{ required: false, message: 'Please input description' }]"
            />
            <van-field
                v-model="userPoap.address"
                placeholder="Address"
                size="large"
                :rules="[{ required: true, message: 'Please input event address' }]"
            />
            <van-field
                v-model="userPoap.start_at_formatted"
                placeholder="Start"
                size="large"
                :rules="[{ required: false, message: 'Please input Start Date (YYYY-MM-DD HH:MM:SS)' }]"
            />
            <van-field
                v-model="userPoap.end_at_formatted"
                placeholder="End"
                size="large"
                :rules="[{ required: false, message: 'Please input End Time (YYYY-MM-DD HH:MM:SS)' }]"
            />

            <van-divider/>

            <van-row justify="left">
                <b>Confirm your current Location</b>
            </van-row>

            <van-divider/>

            <van-cell-group>
                <van-radio-group >
                    <van-cell-group inset>
                        <van-cell v-for="userLocation in userLocations" :key="userLocation.id"
                                  :title="userLocation.full_address" clickable
                                  @click="userPoap.user_location_id = userLocation.id">
                            <template #right-icon>
                                <van-radio :name="userLocation.id" :checked="userPoap.user_location_id === userLocation.id"/>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </van-cell-group>

            <van-divider/>

            <van-row justify="left">
                <b>Upload Proofs</b>
            </van-row>
            <van-divider/>

            <van-uploader>
                <template #preview-cover="{ file }">
                    <div class="preview-cover van-ellipsis">{{ file.name }}</div>
                </template>
            </van-uploader>
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-button v-if="route.params.id === '0'" block round type="success" native-type="submit">
                CheckIn
            </van-button>
            <van-button v-else block round type="success" native-type="submit">
                Checkout
            </van-button>
        </van-cell-group>

    </van-form>
</template>
